import React from "react";
import styled from "styled-components";
import { SourceProps, SourceType } from "Data/detail";
import YouTube from "react-youtube";

interface SliderListProps {
	data: SourceProps;
	className?: string;
	setIsVideoPlay?: React.Dispatch<React.SetStateAction<boolean>>;
}

const Wrapper = styled.li`
	height: 100%;
`;
const Inner = styled.div`
	height: 100%;
	position: relative;
`;
const InnerImage = styled(Inner) <{ image: string }>`
	${(props) => props.theme.layout.full_image(props.image)};
`;
const InnerVideo = styled(YouTube)`
	position: absolute;
	width: 100%;
	height: 100%;
	left: 0;
	top: 0;
`;

const SliderList: React.FC<SliderListProps> = ({ data, className, setIsVideoPlay }) => {
	const handlePlayRunning = () => {
		if (setIsVideoPlay !== undefined) {
			setIsVideoPlay(true);
		}
	};
	const handlePlayStop = () => {
		if (setIsVideoPlay !== undefined) {
			setIsVideoPlay(false);
		}
	};

	return (
		<Wrapper className={className}>
			{data.type === SourceType.IMAGE ? (
				<InnerImage image={data.value} />
			) : (
					<Inner>
						<InnerVideo
							videoId={data.value} // defaults -> null
							// id={string}                       // defaults -> null
							// className={string}                // defaults -> null
							// containerClassName={string}       // defaults -> ''
							// opts={obj}                        // defaults -> {}
							// onReady={func}                    // defaults -> noop
							onPlay={handlePlayRunning} // defaults -> noop
							onPause={handlePlayStop} // defaults -> noop
							onEnd={handlePlayStop} // defaults -> noop
						// onError={func}                    // defaults -> noop
						// onStateChange={func}              // defaults -> noop
						// onPlaybackRateChange={func}       // defaults -> noop
						// onPlaybackQualityChange={func}    // defaults -> noop
						/>
					</Inner>
				)}
		</Wrapper>
	);
};

export default SliderList;
